import LocalStorageService from "services/LocalStorageService";

// Flag persisted while the user is away on the third-party OAuth page so that,
// when the provider redirects back to the registered web redirect URI (the app root),
// the callback can be routed to the mobile connect page instead of My Account.
const STORAGE_KEY = "mobileConnectService";
const EXPIRY_MS = 15 * 60 * 1000;

export const CONNECT_SERVICES = {
  garmin: "garmin",
  suunto: "suunto",
  coros: "coros",
  strava: "strava",
  gpsspeedsurfing: "gpsspeedsurfing"
};

export const CONNECT_SERVICE_LABELS = {
  [CONNECT_SERVICES.garmin]: "Garmin",
  [CONNECT_SERVICES.suunto]: "Suunto",
  [CONNECT_SERVICES.coros]: "COROS",
  [CONNECT_SERVICES.strava]: "Strava",
  [CONNECT_SERVICES.gpsspeedsurfing]: "GPS-Speedsurfing"
};

export const setPendingMobileConnect = (service: string): void => {
  LocalStorageService.set(STORAGE_KEY, JSON.stringify({service, startedAt: Date.now()}));
};

export const getPendingMobileConnect = (): string | null => {
  const raw = LocalStorageService.get(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    const {service, startedAt} = JSON.parse(raw);
    if (!(CONNECT_SERVICES as any)[service] || !startedAt || Date.now() - startedAt > EXPIRY_MS) {
      LocalStorageService.remove(STORAGE_KEY);
      return null;
    }
    return service;
  } catch {
    LocalStorageService.remove(STORAGE_KEY);
    return null;
  }
};

export const clearPendingMobileConnect = (): void => {
  LocalStorageService.remove(STORAGE_KEY);
};
